import { VariantProps } from 'class-variance-authority';
import { ComponentPropsWithoutRef, ReactNode, forwardRef } from 'react';
import { WithIcon } from '../../types/component.types';
import { button } from '../Button/base';

type ButtonProps = VariantProps<typeof button> &
  Omit<ComponentPropsWithoutRef<'button'>, 'className' | 'children'> &
  WithIcon & { children: ReactNode };

/**
 * Icon buttons are default buttons with an icon element.
 *
 * @example
 * ```tsx
 * <IconButton intent="secondary"> <KeyIcon /> </IconButton>
 * ```
 */
// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
export const IconButton = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      intent,
      size,
      type = 'button',
      children,
      disabled,
      width,
      onClick,
      ...buttonProps
    },
    ref,
  ) => {
    return (
      <button
        type={type}
        ref={ref}
        className={button({ intent, purpose: 'icon', size, width })}
        aria-disabled={disabled}
        onClick={disabled ? (e) => e.preventDefault() : onClick}
        {...buttonProps}
      >
        {children}
      </button>
    );
  },
);

IconButton.displayName = 'IconButton';
